import React from 'react';

function StringEditor(props) {

    if (typeof(props.id) != 'string') {
        throw new TypeError("Required ID prop has not been set")
    }

    const onEditorChange = (e) => {
        // Bubble the event up to the calling component
        if (props.onChange) {
            props.onChange({ originalEvent: e, value: e.target.value, props: props });
        }
    }

    var input = (<input type="text" className="" value={props.value} onChange={onEditorChange} tabIndex={props.tabIndex} />);

    return (
        (props.naked ?
            {input}
            :
        <td className={props.className || "control"} colSpan={props.colSpan}>
            {input}
        </td>
        )
    )
}

export default StringEditor;